import { EmptyState as MantineEmptyState } from '@mantine/core'
import type { ReactNode } from 'react'

/**
 * Nothing to show yet (UX spec §4.5): an icon, a one-line title, one sentence and at least one action that fixes it,
 * so an empty page is never a dead end.
 */
export function EmptyState(props: { icon: ReactNode; title: string; body: ReactNode; action: ReactNode }) {
  return (
    <MantineEmptyState
      icon={props.icon}
      title={props.title}
      description={props.body}
      py="xl"
      px="md"
      styles={{ indicator: { color: 'var(--mantine-color-dimmed)' }, title: { fontWeight: 600 } }}
    >
      <MantineEmptyState.Actions>{props.action}</MantineEmptyState.Actions>
    </MantineEmptyState>
  )
}
